// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .overview_dashboard_overview_container__O51XR{ 
    display: flex;
    flex:  5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
    /* margin: 1.5rem; */
 }

 .overview_dashboard_body_container__-MYh6 {
  width: 100%;
 }

.overview_featured__bcqtS {
  width: 100%;
  display: flex;
  flex: 1 1; 
  flex-direction: row;} 

.overview_featuredNoDataAlert__macsu {
  display: flex;
  align-self: center;
  justify-content: center;
  min-height: 100%;
  padding: 30px;
  border-radius: 10px;
  cursor: default ;
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.overview_flex_row_container__SFKSl{
  display: flex;
  flex-direction: row;
  flex-grow: 1; 
  width: 100%; 
  height: fit-content;

  align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
 
}
.overview_breadcrumbs__fQ0NH{
  width: 100%;
  display: flex;
  flex: 1 1; 
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  background-color: var(--hsrcBackgroundLight);
  padding-bottom: 4.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/pages/Dashboard/overview.module.css"],"names":[],"mappings":"CAAC;IACG,aAAa;IACb,UAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb,oBAAoB;CACvB;;CAEA;EACC,WAAW;CACZ;;AAED;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,mBAAmB,CAAC;;AAEtB;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAEhB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;;EAEnB,uBAAuB;IACrB,yBAAyB;IACzB,2BAA2B;;AAE/B;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;EAC5C,sBAAsB;AACxB","sourcesContent":[" .dashboard_overview_container{ \r\n    display: flex;\r\n    flex:  5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n    /* margin: 1.5rem; */\r\n }\r\n\r\n .dashboard_body_container {\r\n  width: 100%;\r\n }\r\n\r\n.featured {\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: row;} \r\n\r\n.featuredNoDataAlert {\r\n  display: flex;\r\n  align-self: center;\r\n  justify-content: center;\r\n  min-height: 100%;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor: default ;\r\n  -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.flex_row_container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-grow: 1; \r\n  width: 100%; \r\n  height: fit-content;\r\n\r\n  align-items: flex-start;\r\n    align-content: flex-start;\r\n    justify-content: flex-start;\r\n \r\n}\r\n.breadcrumbs{\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: row;\r\n  align-content: center;\r\n  justify-content: flex-start;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  padding-bottom: 4.5rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard_overview_container": `overview_dashboard_overview_container__O51XR`,
	"dashboard_body_container": `overview_dashboard_body_container__-MYh6`,
	"featured": `overview_featured__bcqtS`,
	"featuredNoDataAlert": `overview_featuredNoDataAlert__macsu`,
	"flex_row_container": `overview_flex_row_container__SFKSl`,
	"breadcrumbs": `overview_breadcrumbs__fQ0NH`
};
export default ___CSS_LOADER_EXPORT___;
